exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.year-range-picker[data-v-5ca222b1] {\n    color: black;\n    text-align: center;\n    font-size: 18px;\n    margin-right: 30px;\n}\n.range-word[data-v-5ca222b1] {\n    margin-left: 10px;\n    margin-right: 10px;\n}\n.year-range-picker .year-picker[data-v-5ca222b1] {\n    max-width: 140.5px;\n}\n.year-range-picker .el-input__prefix[data-v-5ca222b1] {\n    top: 4%;\n}\n[data-v-5ca222b1] .el-input__prefix {\n    top: 0 !important;\n}\n[data-v-5ca222b1] .el-input__suffix {\n    top: 26% !important;\n}\n  ", ""]);

// exports
